export default __webpack_public_path__ + "static/media/decada-0080-0008-min.6f155015.jpg";